import { ModuleBase } from "@/modules/base";
import { CreateElement } from "vue";
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { Profile } from "./Profile";
import ProfileWindow from './ProfileWindow/index.vue';
import AnalysisMenu from './AnalysisMenu.vue'
import LinearSelectionContextMenu from './LinearSelectionContextMenu.vue'
import ProfileSurfaceLayer from "./Profile/SurfaceLayer.vue";
import { env } from '@/env';
import { store } from '@/store';

@Component
export class ObjectProfileModule extends Mixins(ModuleBase) {
  showWindow = false

  profiles: Profile[] = []

  get outlet() {
    return {
      window: ProfileWindows,
      analysisMenu: AnalysisMenu,
      surfaceLayer: SurfaceLayer,
      linearSelectionContextMenu: LinearSelectionContextMenu,
    } as any
  }

  async load() {
    const line = store.modules.tool.line
    const release = env.releases.default
    line && this.profiles.push(Profile.make({
      line,
      release,
      rerun: release.defaultRerun,
      filter: release.defaultFilter,
    }))
  }
}

@Component
class ProfileWindows extends Vue {
  render(h: CreateElement) {
    return h('div', store.modules.objectProfile.profiles.map((profile) => {
      return h(ProfileWindow, {
        props: {
          module: store.modules.objectProfile,
          profile,
        },
        key: this.Id(profile),
      })
    }))
  }
}

@Component
class SurfaceLayer extends Vue {
  render(h: CreateElement) {
    return h('div', store.modules.objectProfile.profiles.map((profile) => {
      return h(ProfileSurfaceLayer, {
        props: { profile },
      })
    }))
  }
}
